import styled from 'styled-components'
import { Row } from 'antd'

import { Card as CardComponent } from 'src/components/Ant'

interface Props {
  ml?: number
  mr?: number
  mt?: number
}

const WrapCard = styled(CardComponent)`
  margin-bottom: 16px;
`

const WrapRow = styled(Row)<Props>`
  margin: ${({ mt }) => (mt >= 0 ? mt : 12)}px
    ${({ mr }) => (mr >= 0 ? mr : 16)}px 24px
    ${({ ml }) => (ml >= 0 ? ml : 16)}px;
`

export { WrapCard, WrapRow }
